<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.checkout.order_type_id') }}:</label>
                <div>
                    <el-select v-model="filterData.order_type_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option :value="1" :label="$t('pages.ecommerce.checkout.order_types.PURCHASE')"></el-option>
                        <el-option :value="2" :label="$t('pages.ecommerce.checkout.order_types.RENEWAL')"></el-option>
                        <el-option :value="3" :label="$t('pages.ecommerce.checkout.order_types.UPGRADE')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.checkout.status_id') }}:</label>
                <div>
                    <el-select v-model="filterData.status_id" class="w-100" :placeholder="$t('common.chooseSelect')" multiple clearable>
                        <el-option :value="0" :label="$t('pages.ecommerce.checkout.statuses.PENDING')"></el-option>
                        <el-option :value="1" :label="$t('pages.ecommerce.checkout.statuses.AWAITING_PAYMENT')"></el-option>
                        <el-option :value="6" :label="$t('pages.ecommerce.checkout.statuses.PARTIALLY_PAID')"></el-option>
                        <el-option :value="2" :label="$t('pages.ecommerce.checkout.statuses.PAID')"></el-option>
                        <el-option :value="7" :label="$t('pages.ecommerce.checkout.statuses.REFUND_REQUESTED')"></el-option>
                        <el-option :value="5" :label="$t('pages.ecommerce.checkout.statuses.REFUNDED')"></el-option>
                        <el-option :value="4" :label="$t('pages.ecommerce.checkout.statuses.CANCELLED')"></el-option>
                        <el-option :value="3" :label="$t('pages.ecommerce.checkout.statuses.FAILED')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.checkout.orderable_type') }}:</label>
                <div>
                    <el-select v-model="filterData.orderable_type" class="w-100" :placeholder="$t('common.chooseSelect')" clearable @change="onOrderableTypeChange">
                        <el-option value="COMPANY" :label="$t('pages.ecommerce.checkout.orderable_types.COMPANY')"></el-option>
                        <el-option value="CUSTOMER" :label="$t('pages.ecommerce.checkout.orderable_types.CUSTOMER')"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10" v-if="filterData.orderable_type">
                <label class="form-label fw-bold">{{ $t('filters.checkout.orderable_id') }}:</label>
                <div>
                    <el-select v-model="filterData.orderable_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable>
                        <el-option v-for="item in orderableOptions" :key="item.id" :value="item.id" :label="formatOrderableLabel(item)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.checkout.product_id') }}:</label>
                <div>
                    <el-select v-model="filterData.product_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable clearable>
                        <el-option v-for="p in products" :key="p.id" :value="p.id" :label="p.name + (p.code ? ' (' + p.code + ')' : '')"></el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckoutFilter",
    data() {
        return {
            filterData: {},
        }
    },
    computed: {
        products() {
            return this.$store.state.ecommerce.product.table?.data || [];
        },
        companies() {
            return this.$store.state.company.table?.data || [];
        },
        users() {
            return this.$store.state.user.table?.data || [];
        },
        orderableOptions() {
            if (this.filterData.orderable_type === 'COMPANY') return this.companies;
            if (this.filterData.orderable_type === 'CUSTOMER') return this.users;
            return [];
        },
    },
    mounted() {
        this.$store.dispatch('ecommerce/product/get', {filterData: {page_limit: 9999}});
    },
    methods: {
        formatOrderableLabel(item) {
            if (this.filterData.orderable_type === 'COMPANY') return item.name;
            const fn = item.firstname || '';
            const ln = item.lastname || '';
            return (fn + ' ' + ln).trim() || item.email || ('#' + item.id);
        },
        onOrderableTypeChange(val) {
            this.filterData.orderable_id = undefined;
            if (val === 'COMPANY') {
                this.$store.dispatch('company/get', {page: {pageSize: 9999}});
            } else if (val === 'CUSTOMER') {
                this.$store.dispatch('user/get', {page: {pageSize: 9999}});
            }
        },
        onReset() {
            this.filterData = {};
            this.onFilter();
        },
        onFilter() {
            this.$emit('onFilter', this.filterData);
        },
    }
}
</script>
